import { render, staticRenderFns } from "./createFollow.vue?vue&type=template&id=287453e0&scoped=true&"
import script from "./createFollow.vue?vue&type=script&lang=js&"
export * from "./createFollow.vue?vue&type=script&lang=js&"
import style0 from "./createFollow.vue?vue&type=style&index=0&id=287453e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287453e0",
  null
  
)

export default component.exports